import React from 'react'
import '../../styles/Navigation.css'
import { MENU_OPTIONS } from '../Layout/menu-options'
import Side_DashboardIcon from 'custom/assets/side-bar/Dashboard_Sidebar.svg'
import { MENU_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import NavCard from './nav-card'
import { getMenuListSelector } from '../../selectors'
import { useSelector } from 'react-redux'

export default function NavigationNew() {
  const { t } = useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['DASHBOARD'] || {}
  return (
    <div className='side-bar-section'>
      <NavCard
        icon={Side_DashboardIcon}
        link={'/dashboard'}
        key={0}
      />
      {Object.keys(menuConfig).length > 0 && MENU_OPTIONS.map((option, index) => (
    <>
      {menuConfig[option.key] &&
        <NavCard
          icon={option.s_icon}
          link={option.link}
          key={index}
        />
      }
    </>
      ))}

      <div className='detailed-view'>
        <NavCard
          icon={Side_DashboardIcon}
          name={t(MENU_KEYS.DASHBOARD)}
          link={'/dashboard'}
          key={0}
          type="selected"
        />
      {Object.keys(menuConfig).length > 0 && MENU_OPTIONS.map((option, index) => (
        <>
          {menuConfig[option.key] &&
          <NavCard
            icon={option.s_icon}
            name={option.title}
            link={option.link}
            key={index}
            type="selected"
          />
           }
        </>
        ))}
      </div>
    </div>
  )
}
